import React from 'react';
import { NavLink } from 'react-router-dom';

interface NavItem {
  to: string;
  label: string;
  icon: string;
}

const navItems: NavItem[] = [
  { to: '/', label: 'Overview', icon: '\uD83D\uDCC1' },
  { to: '/users', label: 'Users', icon: '\uD83D\uDC64' },
  { to: '/economy', label: 'Economy', icon: '\uD83D\uDCB0' },
  { to: '/matches', label: 'Matches', icon: '\uD83C\uDFAE' },
  { to: '/moderation', label: 'Moderation', icon: '\uD83D\uDEE1' },
  { to: '/system', label: 'System', icon: '\u2699' },
  { to: '/rankings', label: 'Rankings', icon: '\uD83C\uDFC6' },
  { to: '/store', label: 'Store', icon: '\uD83D\uDECD\uFE0F' },
];

export default function Sidebar() {
  return (
    <div className="admin-sidebar">
      <div className="admin-sidebar__header">Explorer</div>
      <nav>
        <ul className="admin-sidebar__nav">
          {navItems.map(item => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `admin-sidebar__item${isActive ? ' admin-sidebar__item--active' : ''}`
                }
              >
                <span className="admin-sidebar__icon">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
